import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const Overline = ({ children, className = "" }) => (
  <span className={`inline-flex items-center gap-3 font-mono text-xs uppercase tracking-[0.22em] text-rp-accent ${className}`}>
    <span className="h-px w-8 bg-rp-accent" />
    {children}
  </span>
);

export const SectionHeading = ({ overline, title, className = "", align = "left" }) => (
  <div className={`${align === "center" ? "text-center" : ""} ${className}`}>
    {overline && <Overline className={align === "center" ? "justify-center" : ""}>{overline}</Overline>}
    <h2 className="mt-5 font-display text-4xl font-light uppercase leading-[0.95] tracking-tight md:text-5xl lg:text-6xl">
      {title}
    </h2>
  </div>
);

export const CtaLink = ({ to, children, variant = "primary", className = "", ...props }) => {
  const base =
    "group inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 font-mono text-xs font-semibold uppercase tracking-[0.14em] transition-colors duration-200";
  const styles =
    variant === "primary"
      ? "bg-rp-accent text-black hover:bg-white"
      : "border border-white/20 text-white hover:border-rp-accent hover:text-rp-accent";
  return (
    <Link to={to} className={`${base} ${styles} ${className}`} {...props}>
      {children}
      <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
    </Link>
  );
};
